import { useState } from "react";

export const useAuth = () => {
  // Inicializacao sincrona: evita flicker null->user entre montagens,
  // que causava loop de redirecionamento "/" <-> "/dashboard".
  const [user] = useState(() => {
    const token = localStorage.getItem("auth_token");
    return token ? { email: token } : null;
  });

  return { user };
};